import React from 'react';
var Games2026 = function () {
    return (React.createElement("div", null,
        React.createElement("header", null,
            React.createElement("h1", null, "Games"),
            React.createElement("nav", null,
                React.createElement("a", { href: "https://jbeat.com" }, "Home"),
                React.createElement("a", { href: "https://blog.jbeat.com" }, "Blog"),
                React.createElement("a", { href: "https://games.jbeat.com" }, "Games"))),
        React.createElement("h1", { style: {
                paddingTop: '15px'
            } }, "Games for 2026"),
        React.createElement("div", { style: {
                display: 'block',
                padding: '15px 30px',
                backgroundColor: '#4CAF50',
                color: 'white',
                textDecoration: 'none',
                borderRadius: '5px',
                minWidth: '200px',
                margin: '20px'
            } }, "Game 1"),
        React.createElement("div", { style: {
                display: 'block',
                padding: '15px 30px',
                backgroundColor: '#2196F3',
                color: 'white',
                textDecoration: 'none',
                borderRadius: '5px',
                minWidth: '200px',
                margin: '20px'
            } }, "Game 2"),
        React.createElement("div", { style: {
                display: 'block',
                padding: '15px 30px',
                backgroundColor: '#FF9800',
                color: 'white',
                textDecoration: 'none',
                borderRadius: '5px',
                minWidth: '200px',
                margin: '20px'
            } }, "Game 3"),
        React.createElement("div", { style: {
                display: 'block',
                padding: '15px 30px',
                backgroundColor: '#4CAF50',
                color: 'white',
                textDecoration: 'none',
                borderRadius: '5px',
                minWidth: '200px',
                margin: '20px'
            } }, "Game 4"),
        React.createElement("div", { style: {
                display: 'block',
                padding: '15px 30px',
                backgroundColor: '#2196F3',
                color: 'white',
                textDecoration: 'none',
                borderRadius: '5px',
                minWidth: '200px',
                margin: '20px'
            } }, "Game 5"),
        React.createElement("div", { style: {
                display: 'block',
                padding: '15px 30px',
                backgroundColor: '#FF9800',
                color: 'white',
                textDecoration: 'none',
                borderRadius: '5px',
                minWidth: '200px',
                margin: '20px'
            } }, "Game 6"),
        React.createElement("div", { style: {
                display: 'block',
                padding: '15px 30px',
                backgroundColor: '#4CAF50',
                color: 'white',
                textDecoration: 'none',
                borderRadius: '5px',
                minWidth: '200px',
                margin: '20px'
            } }, "Game 7"),
        React.createElement("div", { style: {
                display: 'block',
                padding: '15px 30px',
                backgroundColor: '#2196F3',
                color: 'white',
                textDecoration: 'none',
                borderRadius: '5px',
                minWidth: '200px',
                margin: '20px'
            } }, "Game 8"),
        React.createElement("div", { style: {
                display: 'block',
                padding: '15px 30px',
                backgroundColor: '#FF9800',
                color: 'white',
                textDecoration: 'none',
                borderRadius: '5px',
                minWidth: '200px',
                margin: '20px'
            } }, "Game 9"),
        React.createElement("div", { style: {
                display: 'block',
                padding: '15px 30px',
                backgroundColor: '#4CAF50',
                color: 'white',
                textDecoration: 'none',
                borderRadius: '5px',
                minWidth: '200px',
                margin: '20px'
            } }, "Game 10"),
        React.createElement("div", { style: {
                display: 'block',
                padding: '15px 30px',
                backgroundColor: '#2196F3',
                color: 'white',
                textDecoration: 'none',
                borderRadius: '5px',
                minWidth: '200px',
                margin: '20px'
            } }, "Game 11"),
        React.createElement("div", { style: {
                display: 'block',
                padding: '15px 30px',
                backgroundColor: '#FF9800',
                color: 'white',
                textDecoration: 'none',
                borderRadius: '5px',
                minWidth: '200px',
                margin: '20px'
            } }, "Game 12"),
        React.createElement("div", { style: {
                display: 'block',
                padding: '15px 30px',
                backgroundColor: '#4CAF50',
                color: 'white',
                textDecoration: 'none',
                borderRadius: '5px',
                minWidth: '200px',
                margin: '20px'
            } }, "Game 13"),
        React.createElement("div", { style: {
                display: 'block',
                padding: '15px 30px',
                backgroundColor: '#2196F3',
                color: 'white',
                textDecoration: 'none',
                borderRadius: '5px',
                minWidth: '200px',
                margin: '20px'
            } }, "Game 14"),
        React.createElement("div", { style: {
                display: 'block',
                padding: '15px 30px',
                backgroundColor: '#FF9800',
                color: 'white',
                textDecoration: 'none',
                borderRadius: '5px',
                minWidth: '200px',
                margin: '20px'
            } }, "Game 15"),
        React.createElement("div", { style: {
                display: 'block',
                padding: '15px 30px',
                backgroundColor: '#4CAF50',
                color: 'white',
                textDecoration: 'none',
                borderRadius: '5px',
                minWidth: '200px',
                margin: '20px'
            } }, "Game 16"),
        React.createElement("div", { style: {
                display: 'block',
                padding: '15px 30px',
                backgroundColor: '#2196F3',
                color: 'white',
                textDecoration: 'none',
                borderRadius: '5px',
                minWidth: '200px',
                margin: '20px'
            } }, "Game 17"),
        React.createElement("div", { style: {
                display: 'block',
                padding: '15px 30px',
                backgroundColor: '#FF9800',
                color: 'white',
                textDecoration: 'none',
                borderRadius: '5px',
                minWidth: '200px',
                margin: '20px'
            } }, "Game 18"),
        React.createElement("div", { style: {
                display: 'block',
                padding: '15px 30px',
                backgroundColor: '#4CAF50',
                color: 'white',
                textDecoration: 'none',
                borderRadius: '5px',
                minWidth: '200px',
                margin: '20px'
            } }, "Game 19"),
        React.createElement("div", { style: {
                display: 'block',
                padding: '15px 30px',
                backgroundColor: '#2196F3',
                color: 'white',
                textDecoration: 'none',
                borderRadius: '5px',
                minWidth: '200px',
                margin: '20px'
            } }, "Game 20"),
        React.createElement("div", { style: {
                display: 'block',
                padding: '15px 30px',
                backgroundColor: '#FF9800',
                color: 'white',
                textDecoration: 'none',
                borderRadius: '5px',
                minWidth: '200px',
                margin: '20px'
            } }, "Game 21"),
        React.createElement("div", { style: {
                display: 'block',
                padding: '15px 30px',
                backgroundColor: '#4CAF50',
                color: 'white',
                textDecoration: 'none',
                borderRadius: '5px',
                minWidth: '200px',
                margin: '20px'
            } }, "Game 22"),
        React.createElement("div", { style: {
                display: 'block',
                padding: '15px 30px',
                backgroundColor: '#2196F3',
                color: 'white',
                textDecoration: 'none',
                borderRadius: '5px',
                minWidth: '200px',
                margin: '20px'
            } }, "Game 23"),
        React.createElement("div", { style: {
                display: 'block',
                padding: '15px 30px',
                backgroundColor: '#FF9800',
                color: 'white',
                textDecoration: 'none',
                borderRadius: '5px',
                minWidth: '200px',
                margin: '20px'
            } }, "Game 24")));
};
export default Games2026;
